import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';

import config from '../../../../config';

import FooterAppLinks from './FooterAppLinks';
import FooterLanguageSwitcher from './FooterLanguageSwitcher';
import FooterLegalLinks from './FooterLegalLinks';

function Footer() {
    const [version, setVersion] = useState('');

    useEffect(() => {
        setVersion(config.version);
    }, []);

    return (
        <footer className="footer sticky-footer text-gray-400">
            <Container className="my-auto">
                <p className="text-center mb-3">
                    <img src={`${config.staticUrl}assets/images/logo-monlivresms-2.png`} alt={config.application.name} width="168" height="46" style={{ height: 'auto' }} /><br />
                </p>
                <div className="links text-center mb-3">
                    <FooterAppLinks />
                </div>
                <FooterLanguageSwitcher />
                <div className="footer-bottom text-center">
                    <FooterLegalLinks />
                    <div className="copyright my-auto">
                        &copy; {new Date().getFullYear()} &middot; {config.application.name} <small>v.{version}</small>
                    </div>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;
